<template>
  <!-- tab 2-->
  <v-tab-item key="2">
    <v-card flat tile class="px-6">
      <v-row>
        <v-col md="3">
          <span>Telephone:</span>
        </v-col>
        <v-col md="9">
          <span
            class="font-weight-bold"
            v-if="userDetails.telephone !== null && userDetails.telephone"
            >{{ userDetails.telephone }}</span
          >
          <span class="font-weight-bold" v-else>Not provided</span>
          <!-- <vue-tel-input v-bind="bindProps" v-model="userDetails.telephone"></vue-tel-input> -->
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col md="3">
          <span>Street Address:</span>
        </v-col>
        <v-col md="9">
          <span
            class="font-weight-bold"
            v-if="userDetails.addresses && userDetails.addresses.streetAddress"
            >{{ userDetails.addresses.streetAddress }}</span
          >
          <span class="font-weight-bold" v-else>Not provided</span>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col md="3">
          <span>Locality:</span>
        </v-col>
        <v-col md="9">
          <span
            class="font-weight-bold"
            v-if="userDetails.addresses && userDetails.addresses.locality"
            >{{ userDetails.addresses.locality }}</span
          >
          <span class="font-weight-bold" v-else>Not provided</span>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col md="3">
          <span>County/City:</span>
        </v-col>
        <v-col md="9">
          <span
            class="font-weight-bold"
            v-if="userDetails.addresses && userDetails.addresses.region"
            >{{ userDetails.addresses.region }}</span
          >
          <span class="font-weight-bold" v-else>Not provided</span>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col md="3">
          <span>Country:</span>
        </v-col>
        <v-col md="9">
          <span
            class="font-weight-bold"
            v-if="userDetails.addresses && userDetails.addresses.country"
            >{{ userDetails.addresses.country }}</span
          >
          <span class="font-weight-bold" v-else>Not provided</span>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col md="3">
          <span>Postcode:</span>
        </v-col>
        <v-col md="9">
          <span
            class="font-weight-bold"
            v-if="userDetails.addresses && userDetails.addresses.postalCode"
            >{{ userDetails.addresses.postalCode }}</span
          >
          <span class="font-weight-bold" v-else>Not provided</span>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col md="3">
          <span>Job Title:</span>
        </v-col>
        <v-col md="9">
          <span
            class="font-weight-bold"
            v-if="userDetails.jobTitle && userDetails.jobTitle"
            >{{ userDetails.jobTitle }}</span
          >
          <span class="font-weight-bold" v-else>Not provided</span>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col md="3">
          <span>Department:</span>
        </v-col>
        <v-col md="9">
          <span
            class="font-weight-bold"
            v-if="userDetails.department && userDetails.department"
            >{{ userDetails.department }}</span
          >
          <span class="font-weight-bold" v-else>Not provided</span>
        </v-col>
      </v-row>
    </v-card>
  </v-tab-item>
  <!-- tab 2-->
</template>
<script>
export default {
  props: ['userDetails'],
};
</script>
